import {DataApi} from '../data-api';
import {PublicationFilter, PublicationSettings} from '../../../plugins/publication/filter';
import {DataApiDistinctValues, DataApiResult, Publication} from '../../../types/data-api';
import {DataApiEndpoint} from '../data-api-endpoint';

/**
 * Endpoint for getting publications.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class PublicationEndpoint extends DataApiEndpoint {
  protected _api: DataApi;

  constructor(api: DataApi) {
    super(api);
    this._api = api;
  }

  /**
   * Finds publications by a filter.
   *
   * @param {PublicationSettings|null} settings Plugin settings
   * @param {PublicationFilter|null} [filter] Filter
   * @returns {Promise<DataApiResult<PublicationEndpoint>>}
   */
  public async find(
    settings: PublicationSettings | null = null,
    filter: PublicationFilter | null = null
  ): Promise<DataApiResult<Publication>> {
    return fetch(this.buildUrl(settings, filter, [
      'dataApi[preset]=publication'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiResult<Publication>) => {
        return response;
      });
  }

  /**
   * Gets distinct values for publications.
   *
   * @param {PublicationSettings|null} [settings] Plugin settings
   * @returns {Promise<DataApiDistinctValues>}
   */
  public async distinctValues(settings: PublicationSettings | null = null): Promise<DataApiDistinctValues> {
    return fetch(this.buildUrl(settings, null, [
      'dataApi[preset]=publication',
      'dataApi[rows]=9999',
      'dataApi[distinctValues]=1'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiDistinctValues) => {
        return response;
      });
  }
}
